import { render, staticRenderFns } from "./form_input_groups.vue?vue&type=template&id=db1188f4"
import script from "./form_input_groups.vue?vue&type=script&lang=js"
export * from "./form_input_groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports